
// import React, { useState } from 'react';
// import { db } from './firebaseConfig';
// import { collection, addDoc } from 'firebase/firestore';

// export default function AdminNotificationSender() {
//   const [title, setTitle] = useState('');
//   const [body, setBody] = useState('');
//   const [loading, setLoading] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!title || !body) return;

//     setLoading(true);
//     try {
//       await addDoc(collection(db, 'notifications'), {
//         title,
//         body,
//         timestamp: new Date().toISOString(),
//       });
//       setTitle('');
//       setBody('');
//       alert('Notification triggered successfully!');
//     } catch (err) {
//       console.error(err);
//       alert('Failed to send notification.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '400px' }}>
//       <h3>Send Admin Notification</h3>
//       <input
//         type="text"
//         placeholder="Title"
//         value={title}
//         onChange={(e) => setTitle(e.target.value)}
//         required
//       />
//       <textarea
//         placeholder="Message Body"
//         value={body}
//         onChange={(e) => setBody(e.target.value)}
//         required
//       />
//       <button type="submit" disabled={loading}>
//         {loading ? 'Sending...' : 'Send Notification'}
//       </button>
//     </form>
//   );
// }















import React, { useState, useEffect } from 'react'
import './new.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import {serverTimestamp, setDoc, doc, addDoc, collection, query, where, writeBatch, onSnapshot } from "firebase/firestore";
import { auth, db, storage, functions } from "../../../firebase";
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom"
import WarningAmber from '@mui/icons-material/WarningAmber';
import Icon from '@mui/material/Icon';
import { httpsCallable } from "firebase/functions";
import { Select, MenuItem, FormControl, InputLabel, TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {
  const [title, setTitle] = useState("")
  const [body, setBody] = useState("")
  // const [message, setMessage] = useState("")
  const [applicationList, setApplicationList] = useState([])
  // const [icon, setIcon] = React.useState('');
  // const [iconColor, setIconcolor] = useState("")
  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const navigate = useNavigate();


  const Spinner = () => {
    return(
      <span className='spinner-container'>
          <span className='loading-spinner'></span>
      </span>
    )
  }



   useEffect(() => {
  
      const collectionRef = collection(db, "visa")
  
      const queryApplicantions = query(collectionRef, where("status", "==", "active"))
  
      const unsub = onSnapshot(queryApplicantions, (snapShot) => {

        let list = [];

        snapShot.docs.forEach((doc) => {

          list.push(doc.data().visaId)

        })

        setApplicationList(list)

      }, 

        (error) => {

          console.log(error)

        }

      );
  
      return () => {
        unsub();
      }
  
  //END LISTEN REAL TIME    
  
    },[])


  //  const handleChangeIcon = (event) => {
  //   setIcon(event.target.value);
  // };

  // const handleChangeIconColor = (event) => {
  //   setIconcolor(event.target.value);
  // };


  const handleSendAdminNotification = async (e) => {

    e.preventDefault()

    if (!title || !body) return;

    setIsloading(true)

    try {

       await addDoc(collection(db, 'notifications'), {
        title,
        body,
        timestamp: new Date().toLocaleString(),
      });
    
      setTitle('');

      setBody('');

      alert('Notification triggered successfully!');

      navigate('/messages')

    } catch (error) {
      console.error('Failed to send announcement:', error.code, error.message);
    } finally {
      setIsloading(false);
    }

  };


//   const selectIcon = [
//   {
//     value: 'customerservice',
//     label: 'Customer Service Icon',
//     icon: ''
//   },
//   {
//     value: 'infocircleo',
//     label: 'Info Icon',
//     icon: ''
//   },
//   {
//     value: 'warning',
//     label: 'Warning Icon',
//     icon: ''
//   },
//   {
//     value: 'Safety',
//     label: 'Safety Icon',
//     icon: ''
//   },
//   {
//     value: 'payment',
//     label: 'Payment Icon',
//     icon: ''
//   },
//    {
//     value: 'clockcircle0',
//     label: 'Time',
//     icon: ''
//   },
//   {
//     value: 'Trophy',
//     label: 'Trophy Icon',
//     icon: ''
//   },
//   {
//     value: 'bulb1',
//     label: 'Bulb Icon',
//     icon: ''
//   },
//   {
//     value: 'rocket1',
//     label: 'Rocket Icon',
//     icon: ''
//   },
    

// ];


//  const selectColor = [
//   {
//     value: '#000',
//     label: 'Black',
//     code: '#000'
//   },
//   {
//     value: '#c61a09',
//     label: 'Red',
//     code: '#c61a09'
//   },
//   {
//     value: '#F4F413',
//     label: 'Yellow',
//     code: '#F4F413'
//   },
//   {
//     value: '#2CBD08',
//     label: 'Green',
//     code: '#2CBD08'
//   },
//   {
//     value: '#1317F4',
//     label: 'Blue',
//     code: '#1317F4'
//   },
//   {
//     value: '#CCCCCC',
//     label: 'Gray',
//     code: '#CCCCCC'
//   },
  
// ];



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>New Message</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/messages"
            >
              Message List
            </Link>
            <Typography color="green">New Message</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
          <div className='right'>
            <div className='form' onSubmit={handleSendAdminNotification}>

                
{/*                  
                  <Box sx={{ minWidth: '50%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="icon" style={{color:'#999', fontWeight:300}}>Select Message Icon</InputLabel>
                    <Select
                      labelId="icon"
                      id="icon"
                      value={icon}
                      label="Icon"
                      onChange={handleChangeIcon}
                     
                    >

                      {selectIcon.map((item) => { 

                        return(

                          <MenuItem value={item.value}>
                          
                            {item.label}
                          </MenuItem>

                        ) 
                      })}

                    </Select>
                    </FormControl>
                  </Box>


                  <Box sx={{ minWidth: '50%' }}>
                    <FormControl fullWidth>
                    <InputLabel id="icon" style={{color:'#999', fontWeight:300}}>Select Icon Color</InputLabel>
                    <Select
                      labelId="color"
                      id="color"
                      value={iconColor}
                      label="Icon Color"
                      onChange={handleChangeIconColor}
                
                    >
                      {selectColor.map((item) => { 

                        return(

                          <MenuItem value={item.value}>
                            
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', gap:40}}>
                                {item.label}
                                <div style={{width:20, height:20, backgroundColor:item.code}}></div>
                            </div>
                          </MenuItem>

                        ) 

                      })}

                    </Select>
                    </FormControl>
                  </Box> */}


                  
                    <TextField
                      id="title"
                      onChange={(e) => setTitle(e.target.value)}
                      value = {title}
                      placeholder="Enter Title"
                      style={{width:'50%'}}


                    />
                    

                    <TextField
                      id="message" 
                      value={body}
                      multiline
                      minRows={3}
                      maxRows={10}
                      placeholder="Enter Message"
                      style={{width:'50%'}}
                      onChange={(e) => setBody(e.target.value)}
                    />


              <Button onClick={handleSendAdminNotification} style={{width:'50%', backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? "... sending notification": 'Send'}</Button>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default New
